import { Navigate, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Eye } from "lucide-react";
import Admin from "@/pages/admin_dashboard/Admin";
import { Button } from "@/components/ui/button";
import { buildAdminUrl } from "@/lib/adminOrigin";
import { DEMO_BUSINESS_NAME } from "./demoMode";

const DemoBanner = () => (
  <div
    role="status"
    className="fixed bottom-4 left-1/2 z-50 flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-xl border border-border bg-card px-4 py-2 text-sm text-foreground shadow-lg"
  >
    <Eye className="h-4 w-4 shrink-0 text-muted-foreground" />
    <span className="hidden sm:inline">
      You're viewing a read-only demo of {DEMO_BUSINESS_NAME}.
    </span>
    <span className="sm:hidden">Read-only demo</span>
    <Button asChild size="sm" className="standard-action-button">
      <a href={buildAdminUrl(window.location, "/auth")}>Start free trial</a>
    </Button>
  </div>
);

/**
 * Routes for the public demo. They mirror the admin app's dashboard route but
 * without ProtectedRoute: the demo client signs in a fixed, read-only user.
 */
const DemoRoutes = () => (
  <>
    <Helmet>
      <title>{`Live demo · ${DEMO_BUSINESS_NAME} · Dibs`}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <Routes>
      <Route path="/" element={<Admin suppressOnboardingTour />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <DemoBanner />
  </>
);

export default DemoRoutes;
